import React from 'react';
import { UnstyledButton } from '@mantine/core';
import type { DraggableAttributes, DraggableSyntheticListeners } from '@dnd-kit/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripVertical } from '@fortawesome/free-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import classes from './drag-handle.module.scss';

export type DragHandleProps = {
  dataTestId: string;
  disabled?: boolean;
  attributes?: DraggableAttributes;
  listeners?: DraggableSyntheticListeners;
  setActivatorNodeRef?: (element: HTMLElement | null) => void;
  onClick?: () => void;
  title?: string;
};

// Architectural summary: Shared drag grip for dnd-kit sortable rows; spreads sortable listeners.
const DragHandleComponent: React.FC<DragHandleProps> = ({
  dataTestId,
  disabled = false,
  attributes,
  listeners,
  setActivatorNodeRef,
  onClick,
  title,
}) => (
  <UnstyledButton
    ref={setActivatorNodeRef}
    className={classes.handle}
    data-testid={dataTestId}
    aria-label={title ?? 'גרור לשינוי סדר'}
    title={title}
    disabled={disabled && !onClick}
    onClick={onClick}
    {...(attributes ?? {})}
    {...(disabled ? {} : listeners ?? {})}
  >
    <FontAwesomeIcon icon={faGripVertical as IconProp} />
  </UnstyledButton>
);

export const DragHandle = React.memo(DragHandleComponent);
